import { type AsyncNamespace, type NexusSignal, defineEvent, otto } from '@otto-ec/global-resources/nexus';
import type { TileListLoaded, TileListLoadedPayload } from '@tilelist/application/ports/TileListLoaded.ts';

declare global {
    interface NexusInterfaces {
        reptile: AsyncNamespace<{
            tileListLoaded: NexusSignal<TileListLoadedPayload>;
        }>;
    }
}

export type TileListLoadedNexus = {
    events: TileListLoaded;
    signal: NexusSignal<TileListLoadedPayload>;
    cleanup(): void;
};

export function createTileListLoadedNexus(): TileListLoadedNexus {
    const cleanup = otto.reptile.assignNamespace({
        tileListLoaded: defineEvent<TileListLoadedPayload>(),
    });
    const { tileListLoaded } = otto.reptile;

    return {
        events: {
            onTileListLoaded: (handler) => tileListLoaded.subscribe((payload) => handler(payload)),
        },
        signal: tileListLoaded,
        cleanup,
    };
}
